import { render, staticRenderFns } from "./OrderMsg.vue?vue&type=template&id=4cf751fa&scoped=true&"
import script from "./OrderMsg.vue?vue&type=script&lang=ts&"
export * from "./OrderMsg.vue?vue&type=script&lang=ts&"
import style0 from "./OrderMsg.vue?vue&type=style&index=0&id=4cf751fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf751fa",
  null
  
)

export default component.exports